import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=348c07ca&scoped=true&"
import script from "./Dialog.vue?vue&type=script&lang=ts&"
export * from "./Dialog.vue?vue&type=script&lang=ts&"
import style0 from "../style.scss?vue&type=style&index=0&id=348c07ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348c07ca",
  null
  
)

export default component.exports